export enum ContactEnum {
  INDIVIDUAL = 'individual',
  COMPANY = 'company',
}

export type ContactType = ContactEnum.INDIVIDUAL | ContactEnum.COMPANY;
